import get from "lodash/get";
import mapValues from "lodash/mapValues";
import { BUILDING_TYPES } from "helpers/supply";
import { START_FETCHING, STOP_FETCHING, UPDATE_BASE, BUILDING_UPDATED } from "../Actions/ActionSupply";

const initialState = {};

const updateBuilding = (base, buildingType, buildingId, modifiers) => {
  const building = base[buildingType];
  return {
    ...base,
    [buildingType]: {
      ...building,
      id: buildingId,
      modifiers: [...building.modifiers, ...modifiers]
    }
  };
};

const emptyBase = {};
Object.values(BUILDING_TYPES).forEach(name => {
  emptyBase[name] = {
    name,
    modifiers: []
  };
});

const fillBase = base => base ? {
  ...emptyBase,
  ...mapValues(base, (building, name) => ({
    ...building,
    name
  }))
} : null;

export const supply = (state = initialState, action) => {
  switch (action.type) {
    case START_FETCHING:
      return {
        ...state,
        [action.clanId]: {
          ...state[action.clanId],
          isFetching: true
        }
      };
    case STOP_FETCHING:
      return {
        ...state,
        [action.clanId]: {
          ...state[action.clanId],
          isFetching: false
        }
      };
    case UPDATE_BASE:
      return {
        ...state,
        [action.clanId]: {
          ...state[action.clanId],
          isFetching: false,
          base: fillBase(action.base)
        }
      };
    case BUILDING_UPDATED:
      return {
        ...state,
        [action.clanId]: {
          ...state[action.clanId],
          isFetching: false,
          base: updateBuilding(get(state, `[${action.clanId}].base`, {}), action.buildingType, action.buildingId, action.modifiers)
        }
      };
    default:
      return state;

  }
};